export default {
  index:'About',
  majorsys:'Major Systems',
  platform:'Specialized Platforms',
  miniapp:'Mini APPs',
};
